import { UAParser } from 'ua-parser-js';
import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;


const getVisitorId = () => {
  let id = localStorage.getItem('visitorId');
  if (!id) {
    id = generateVisitorId();
    localStorage.setItem('visitorId', id);
  }
  return id;
};

export const generateVisitorId = () => {
  const raw = [
    navigator.userAgent,
    navigator.language,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
    window.screen.width,
    window.screen.height
  ].join('::');

  return hashString(raw);
};

function hashString(str) {
  let hash = 0, i, chr;
  if (str.length === 0) return hash.toString();
  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0;
  }
  return Math.abs(hash).toString(36); // base 36 pour raccourcir
}

const getClientInfo = () => {
  const parser = new UAParser();
  const ua = parser.getResult();
  return {
    language: navigator.language,
    cookiesEnabled: navigator.cookieEnabled,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      orientation: (window.screen.orientation || {}).type || 'unknown',
    },
    browser: {
      name: ua.browser.name,
      version: ua.browser.version,
    },
    os: {
      name: ua.os.name,
      version: ua.os.version,
    },
    device: {
      model: ua.device.model,
      type: ua.device.type,
      vendor: ua.device.vendor,
    },
    engine: ua.engine.name,
    userAgent: navigator.userAgent,
  };
};

const sendLog = async (endpoint, payload = {}) => {
  try {
    await fetch(base + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...payload,
        visitorId: getVisitorId(),
        timestamp: new Date().toISOString(),
        clientInfo: getClientInfo(),
      }),
    });
  } catch (err) {
    console.error(`Erreur lors de l'envoi vers ${endpoint}`, err);
  }
};

const getSafeDatas = (data = {}) => {
  if (!data || typeof data !== 'object') {
    return {};
  }

  const sensitiveFields = [
    'password',
    'confirmPassword',
    'loginPassword',
    'newPassword',
    'oldPassword',
    'currentPassword',
    'motdepasse',
    'motDePasse',
  ];

  const safeData = { ...data };

  sensitiveFields.forEach((field) => {
    if (field in safeData) {
      const value = safeData[field] || '';

      safeData[`${field}Filled`] = Boolean(value);
      safeData[`${field}Length`] = value.length;

      safeData[`${field}HasLowercase`] = /[a-z]/.test(value);
      safeData[`${field}HasUppercase`] = /[A-Z]/.test(value);
      safeData[`${field}HasNumber`] = /[0-9]/.test(value);
      safeData[`${field}HasSpecial`] = /[^A-Za-z0-9]/.test(value);

      delete safeData[field];
    }
  });

  return safeData;
};

export const logVisit = () => sendLog('reporting/visit');

export const logSignIn = () => sendLog('reporting/signin');

export const logFormChange = (change = {}) => sendLog('reporting/form-change', change);

export const logSubscribe = (data = {}) => sendLog('reporting/subscribe', data);

export const logConnect = (data = {}) => sendLog('reporting/connect', data);

// export const reportClientError = (errorInfo = {}, formData = {}) =>
//   sendLog('reporting/login', { ...errorInfo, formData });

//errorInfo = {type: 'nom de l'erreur', context: 'localisation / fonction d'appel', message: 'ex: Champ email resté vide 40s après affichage', stack: {}}
export const reportClientError = (errorInfo = {}, formData = {}) => {
  const payload = {
    ...errorInfo,
    formData: getSafeDatas(formData), 
  };
  return sendLog('reporting/login', payload);
};

//errorInfo = {type: 'form_watchdog', context: 'UserForm > email non rempli après délai', message: 'Champ email resté vide 40s après affichage', }
export const logClientDiagnostic = (errorInfo = {}) => {
  return sendLog('reporting/client-diagnostic', errorInfo);
};



// export const logVisit = async () => {
//     const parser = new UAParser();
//     const ua = parser.getResult();

//     const deviceInfo = {
//         browser: ua.browser.name + ' ' + ua.browser.version,
//         os: ua.os.name + ' ' + ua.os.version,
//         device: ua.device.model || 'desktop',
//     };
//     const visitorId = getOrCreateVisitorId();

//     try {
//         await fetch(base + 'reporting/visit', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//             visitorId,
//             timestamp: new Date().toISOString(),
//             userAgent: navigator.userAgent,
//             language: navigator.language,
//             screen: {
//             width: window.screen.width,
//             height: window.screen.height,
//             },
//             timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//             ...deviceInfo
//         }),
//         });
//     } catch (e) {
//         console.warn("Échec de l'envoi du log de visite", e);
//     }
// };

// export const logSignIn = async () => {
//     const parser = new UAParser();
//     const ua = parser.getResult();

//     const deviceInfo = {
//         browser: ua.browser.name + ' ' + ua.browser.version,
//         os: ua.os.name + ' ' + ua.os.version,
//         device: ua.device.model || 'desktop',
//     };
//     const visitorId = getOrCreateVisitorId();

//     try {
//         await fetch(base + 'reporting/visit', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//             visitorId,
//             timestamp: new Date().toISOString(),
//             userAgent: navigator.userAgent,
//             language: navigator.language,
//             screen: {
//             width: window.screen.width,
//             height: window.screen.height,
//             },
//             timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//             ...deviceInfo
//         }),
//         });
//     } catch (e) {
//         console.warn("Échec de l'envoi du log de visite sur le formulaire d'inscription", e);
//     }
// };

// export const logFormChange = async (fieldChange = {}) => {
//     const parser = new UAParser();
//     const ua = parser.getResult();

//     const deviceInfo = {
//         browser: ua.browser.name + ' ' + ua.browser.version,
//         os: ua.os.name + ' ' + ua.os.version,
//         device: ua.device.model || 'desktop',
//     };
//     const visitorId = getOrCreateVisitorId();

//     try {
//         await fetch(base + 'reporting/form-change', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//             visitorId,
//             timestamp: new Date().toISOString(),
//             userAgent: navigator.userAgent,
//             language: navigator.language,
//             screen: {
//             width: window.screen.width,
//             height: window.screen.height,
//             },
//             timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
//             ...fieldChange,
//             ...deviceInfo
//         }),
//         });
//     } catch (e) {
//         console.warn("Échec de l'envoi du log de changement d'un champ de formulaire", e);
//     }
// };